var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");